import React from 'react'

function Support() {
  return (
    <div><br /><br /><br /><br />
        <h1 align='center'><b>support Page</b> </h1><br /></div>
  )
}

export default Support